import { Component, AfterContentInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { equals, join, isNil, gt, isEmpty } from 'ramda';
import { setValue } from '@app/helpers/form.helpers';
import { setRequired } from '@app/helpers/form-control.helpers';
import { isNo, isYes, setValueNo, setValueYes } from '@app/helpers/tayn.helpers';
import { SectionFormDirective } from '@app/classes/section-form.class';
import { toggles, swapControls, swapControl } from '@app/helpers/forms.helpers';
import { isOther, isSelf, isAssistingPerson, permissionCodes } from '@app/helpers/models.helpers';
import { codeEqual } from '@app/helpers/code.helpers';
import { minus9Days } from "@app/helpers/date.helpers";
import { getDataValue } from '@app/helpers/object.helpers';
import { ApiService } from '../../../../gateway/services/api.service';
import { ProcessService } from '../../../../services/process.service';
import { FormBuilder } from '@angular/forms';
import { ModalService } from '../../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { formatTableData } from '@app/helpers/tables.helpers';
import { SigninService } from '@app/gateway/signin/signin.service';
import { isApplyForBenefits, isChangeReport, isRedeMode, isRmbRmc } from '@app/helpers/mode.helpers';
import Vs from '@app/services/validators/validators.service';
import { Title } from '@angular/platform-browser';
import { ServiceConfigService } from '@app/services/service-config.service';
import { formatDate } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '@app/services/token/token.service';

@Component({
    templateUrl: './household.component.html',
    styleUrls: ["./household.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})




export class HouseholdComponent extends SectionFormDirective implements AfterContentInit, OnDestroy {
  fullName;
  assistingPersonFullName;
  errorMessage = false;
  partnerName: string;
  showCommonCtrls = false;
  modifiedPAddress = false;
  showAssistingProof = false;
  showAssistingNotices = false;
  caseheadPopoverText;
  assistingPersonPop1;
  assistingPersonPop2;
  languagePopup;
  minimumDate = minus9Days();
  today: any = new Date();
  isFullCoverageApp = false;
  appType = sessionStorage.getItem('appType');
  user = sessionStorage.getItem('userType');
  isAHS = sessionStorage.getItem('isKepro');
  isPpRmbRmc = (this.appType === 'RB' || this.appType === 'RC') && this.user === 'RP';
  toolTip: boolean;
  letterLanguage;
  isMedicAidApp = this.user === 'RP' && this.appType === 'AFB' && !this.isAHS;
  addressSub: Subscription;
  defaultLanguage;
  translatedLang;
  appKey;
  appKey2;
  applicantBehalf1;
  isRmbRmc;
  isAssistingPersonNameSameAsHoh = false;
  isFinReassessment = false;
  isKepro = false;
  isInvalidOrgName = false;
  isInvalidIdNumber = false;
  firstName;
  lastName;
  userData;
  previousAssistingFirstName: string;
  previousAssistingLastName: string;
  ismode = sessionStorage.getItem('mode');
  viewTCC = JSON.parse(sessionStorage.getItem('ViewTCC'));
  currentDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
  showWellpoint: boolean = false;
  validSahMailId = false;
  isInvalidSahMailId = false;
  sahmask = '';
  isTooltipExpanded = false;
  globalLanguage = sessionStorage.getItem('globalTranslatedLan') ? sessionStorage.getItem('globalTranslatedLan') : null;

  //For AHS AFB, RMC, RMC
  isAhsRmbOrRmc = (this.isAHS && this.user === 'RP') &&
    ( this.appType === 'REDETERMINATION' || this.appType === 'RB' ||  this.appType === 'CHANGE_REPORT' || this.appType === 'RC' || this.appType === 'AFB') &&
    (this.ismode === 'REDETERMINATION' || this.ismode === 'NEW' || this.ismode === 'CHANGE_REPORT');

  isAhsAfb = (this.isAHS && this.user === 'RP') && this.appType === 'AFB' && this.ismode === 'NEW';
  isAhsRmb = (this.isAHS && this.user === 'RP') && (this.appType === 'RB' || this.appType === 'REDETERMINATION') && this.ismode === 'REDETERMINATION';
  isAhsRmc = (this.isAHS && this.user === 'RP') && (this.appType === 'RC' || this.appType === 'CHANGE_REPORT') && this.ismode === 'CHANGE_REPORT';
  isPreterm = sessionStorage.getItem('isPreterm') === "PRETERM" && (sessionStorage.getItem('appType') === 'RB' || (sessionStorage.getItem('appType') === 'REDETERMINATION'  && sessionStorage.getItem('isKepro') === "true"));
  isEbmsDriverFlow = JSON.parse(sessionStorage.getItem("embsDriverFlow"))

  ppViewTccHoHrmbrmc = ((this.appType === 'RC' || this.appType === 'RB') && this.user === 'RP' && this.viewTCC && !this.isFinReassessment);
  constructor(private modalService: ModalService, builder: FormBuilder, public processService: ProcessService, public apiService: ApiService,
    public translateService: TranslateService, public signinService: SigninService, private titleService: Title, private readonly serviceConfigService: ServiceConfigService, private cdr: ChangeDetectorRef, private token: TokenService) {
    super(builder);
    this.addressSub = this.processService.processAddressValidate.subscribe((action) => this.addressValidate(action));
    this.titleService.setTitle('Household Information');
  }

  addressValidate(action) {

    const appNum = this.applicationNumber;
    const formData = this.formGroup.value.data;
    const physical = getDataValue('physicalAddress.address', formData);
    const physicalFormat = getDataValue('physicalAddress.addressFormat', formData);
    const isSaveExit = equals(action, 'fromSaveExit') ? true : false;

    const mailing = getDataValue('mailingAddress.address', formData);
    const mailingFormat = getDataValue('mailingAddress.addressFormat', formData);

    const assisting = getDataValue('assistingPerson.address', formData);
    const assistingFormat = getDataValue('assistingPerson.addressFormat', formData);

    const postObject = {
      addressList: [
        { addressType: 'PHYSICAL', originalAddress: physical },
        { addressType: 'MAILING', originalAddress: mailing },
        { addressType: 'ASSISTING', originalAddress: assisting }
      ]
    };

    if (isNil(physical) || codeEqual('MI', physicalFormat)) {
      postObject.addressList.splice(0, 1);
    }

    if (isNil(mailing) || codeEqual('MI', mailingFormat)) {
      equals(postObject.addressList.length, 2) ? postObject.addressList.splice(0, 1) : postObject.addressList.splice(1, 1);
    }

    if (isNil(assisting) || codeEqual('MI', assistingFormat)) {
      equals(postObject.addressList.length, 1) ? postObject.addressList.splice(0, 1) : gt(postObject.addressList.length, 2) ? postObject.addressList.splice(2, 1) : postObject.addressList.splice(1, 1);
    }

    if (isEmpty(postObject.addressList)) {
      this.processService.addressValidated = true;
    } else {
      this.apiService.post('applications/' + appNum + '/sections/HHAPL/address', postObject, {headers: new HttpHeaders({'pageId': 'HHAPL', 'sessionId' : this.token.getSessionId()})}, true).subscribe((res) => {
        if (!isNil(res)) {
          this.modalService.openAddressModal(res, isSaveExit).subscribe(result => {
            if (result !== true) {
              if (result) {
                const phyIndex = result.findIndex(i => i.addressType === 'PHYSICAL');
                const mailIndex = result.findIndex(i => i.addressType === 'MAILING');
                const assisIndex = result.findIndex(i => i.addressType === 'ASSISTING');
                if (phyIndex === 0) {
                  const addressLine1 = this.getControl('data.physicalAddress.address.addressLine1', this.formGroup);
                  const addressLine2 = this.getControl('data.physicalAddress.address.addressLine2', this.formGroup);
                  const city = this.getControl('data.physicalAddress.address.city', this.formGroup);
                  const state = this.getControl('data.physicalAddress.address.state', this.formGroup);
                  const zip = this.getControl('data.physicalAddress.address.zip', this.formGroup);

                  if (result[0].selectedAddress === 'Suggested') {
                    addressLine1.setValue(result[0].suggestedAddress.addressLine1);
                    addressLine2.setValue(result[0].suggestedAddress.addressLine2);
                    city.setValue(result[0].suggestedAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[0].suggestedAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[0].suggestedAddress.zip);
                  } else if (result[0].selectedAddress === 'Original') {
                    addressLine1.setValue(result[0].originalAddress.addressLine1);
                    addressLine2.setValue(result[0].originalAddress.addressLine2);
                    city.setValue(result[0].originalAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[0].originalAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[0].originalAddress.zip);
                  }
                };
                if (mailIndex === 0 || mailIndex === 1) {
                  const idx = mailIndex;
                  const addressLine1 = this.getControl('data.mailingAddress.address.addressLine1', this.formGroup);
                  const addressLine2 = this.getControl('data.mailingAddress.address.addressLine2', this.formGroup);
                  const city = this.getControl('data.mailingAddress.address.city', this.formGroup);
                  const state = this.getControl('data.mailingAddress.address.state', this.formGroup);
                  const zip = this.getControl('data.mailingAddress.address.zip', this.formGroup);

                  if (result[idx].selectedAddress === 'Suggested') {
                    addressLine1.setValue(result[idx].suggestedAddress.addressLine1);
                    addressLine2.setValue(result[idx].suggestedAddress.addressLine2);
                    city.setValue(result[idx].suggestedAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[idx].suggestedAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[idx].suggestedAddress.zip);
                  } else if (result[idx].selectedAddress === 'Original') {
                    addressLine1.setValue(result[idx].originalAddress.addressLine1);
                    addressLine2.setValue(result[idx].originalAddress.addressLine2);
                    city.setValue(result[idx].originalAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[idx].originalAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[idx].originalAddress.zip);
                  }
                };

                if (assisIndex === 1 || assisIndex === 2) {
                  const idx = assisIndex;
                  const addressLine1 = this.getControl('data.assistingPerson.address.addressLine1', this.formGroup);
                  const addressLine2 = this.getControl('data.assistingPerson.address.addressLine2', this.formGroup);
                  const city = this.getControl('data.assistingPerson.address.city', this.formGroup);
                  const state = this.getControl('data.assistingPerson.address.state', this.formGroup);
                  const zip = this.getControl('data.assistingPerson.address.zip', this.formGroup);

                  if (result[idx].selectedAddress === 'Suggested') {
                    addressLine1.setValue(result[idx].suggestedAddress.addressLine1);
                    addressLine2.setValue(result[idx].suggestedAddress.addressLine2);
                    city.setValue(result[idx].suggestedAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[idx].suggestedAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[idx].suggestedAddress.zip);
                  } else if (result[idx].selectedAddress === 'Original') {
                    addressLine1.setValue(result[idx].originalAddress.addressLine1);
                    addressLine2.setValue(result[idx].originalAddress.addressLine2);
                    city.setValue(result[idx].originalAddress.city);
                    const selectedState = this.tables.STATE.filter(s => s.code == result[idx].originalAddress.state.code)[0];
                    state.setValue(selectedState);
                    zip.setValue(result[idx].originalAddress.zip);
                  }
                };
                this.processService.addressValidated = true;
              }
            }
          }, () => {
            this.processService.addressValidated = true;
          })
        } else {
          this.processService.addressValidated = true;
        }
      })
    }

  }

  isDateOfApplicationEnabled() {
    const val = this.getControl('data.physicalAddress.applicationSource');
    if (val.value != undefined && val.value != null && val.value.code != 'T')
      return true;
    return false;
  }

  showAssistPerson() {
    this.modalService.openAssistPersonTypes();
  }
  isAssistingPersonAndAckSignSwSame() {
    const assistingPersonSignName = this.getControl('data.assistingPerson.applicantSignName');
    const ackSignSw = this.getControl('data.assistingPerson.assistingPersonSignName');
    const val1 = assistingPersonSignName?.value;
    const val2 = ackSignSw?.value;
    // If both values are empty, null, or undefined, return false
    if (!val1 && !val2) {
      return false;
    }    
    return val1 === val2; 
  }

  onTooltipClick(event: MouseEvent) {
    // Don't toggle if clicking on a link inside the tooltip
    const target = event.target as HTMLElement;
    if (target.tagName === 'A' || target.closest('a')) {
      return; // Let the link handle the click
    }
    this.toggleTooltip();
  }

  onTooltipButtonKeydown(event: KeyboardEvent) {
    // This handler is only for the button itself (icon)
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      this.toggleTooltip();
    }
  }

  onTooltipContentKeydown(event: KeyboardEvent) {
    // This handler is for content inside the tooltip
    const focusedElement = document.activeElement as HTMLElement;
    const isLinkFocused = focusedElement && (focusedElement.tagName === 'A');
    
    console.log('Content keydown - Key:', event.key, 'Focused element:', focusedElement?.tagName, 'Is link:', isLinkFocused);
    
    // If a link has focus and Enter/Space is pressed, let it navigate
    if (isLinkFocused && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      const linkElement = focusedElement as HTMLAnchorElement;
      if (linkElement && linkElement.href) {
        console.log('Navigating to:', linkElement.href, 'Target:', linkElement.target);
        window.open(linkElement.href, linkElement.target || '_self');
      }
      return;
    }
    
    // Close tooltip on Escape
    if (event.key === 'Escape' && this.isTooltipExpanded) {
      event.preventDefault();
      this.isTooltipExpanded = false;
      this.cdr.detectChanges();
      // Return focus to the tooltip button
      const tooltipButton = document.querySelector('.nh-tooltip [role="button"]') as HTMLElement;
      if (tooltipButton) {
        tooltipButton.focus();
      }
    }
  }

  toggleTooltip() {
    this.isTooltipExpanded = !this.isTooltipExpanded;
    this.cdr.detectChanges();
  }

  onChange(event, val?) {
    const name = this.getControl('data.assistingPerson.name');
    const applicantBehalf = this.getControl('data.assistingPerson.responsibilities.applicantBehalf')
    const submitRenewal = this.getControl('data.assistingPerson.responsibilities.submitRenewal');
    const otherLetter = this.getControl('data.assistingPerson.responsibilities.letterOtherCommunication');
    const applicantAckSignSw = this.getControl('data.assistingPerson.applicantAckSignSw');
    const applicantSignName = this.getControl('data.assistingPerson.applicantSignName');
    const setVal = (c, v) => setValue(c, v);
    const setAppBehalf = () => setVal("A", applicantBehalf);
    const setSubRenewal = () => setVal("S", submitRenewal);
    const setOtherLtr = () => setVal("L", otherLetter);

    const resetAppBehalf = () => applicantBehalf.reset();
    const resetSubmitRen = () => submitRenewal.reset();
    const resetOther = () => otherLetter.reset();
    if (event.target ?.checked === true && val) {
      switch (val) {
        case 'S':
          setAppBehalf();
          break;
        case 'L':
          setAppBehalf();
          setSubRenewal();
          break;
        case 'Y':
          setAppBehalf();
          setSubRenewal();
          setOtherLtr();
          break;
      }
      applicantBehalf.setValidators(null);
      applicantBehalf.setErrors(null);
    } else if (event.target ?.checked === false && val) {
      switch (val) {
        case 'S':
          resetAppBehalf();
          break;
        case 'L':
          resetAppBehalf();
          resetSubmitRen();
          break;
        case 'Y':
          resetAppBehalf();
          resetSubmitRen();
          resetOther();
          break;
      }
    } else if (event.code === 'AR' || event.code === 'OH') {

      applicantBehalf.setValidators(Vs.required);
      applicantBehalf.updateValueAndValidity();
      if(event.code === 'AR'){
        applicantAckSignSw.enable();
        applicantAckSignSw.setValue('');
        applicantAckSignSw.setValidators( Vs.required);
        applicantAckSignSw.updateValueAndValidity();
        applicantSignName.enable();
        applicantSignName.setValue('');
        applicantSignName.setValidators([Vs.required, Vs.maxLength(93), Vs.signatureName]);
      }

    } else if(event.code === 'Y' && val === 'AssistPerson' && this.isKepro){
      name.patchValue({firstName: this.firstName, lastName:this.lastName })
    } else {

      //MP condition
      const condition1 = (this.user !== 'RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc) && (this.getValue('data.assistingOnBehalf').value === 'Assisting Person' || this.getValue('data.assistingOnBehalf').value === 'Persona que Ayuda' || this.isY('data.addAssistingPersonToApp'));
      //PP FRM condition
      const condition2 = ((this.isY('data.ppAddAssistingPersonToApp') || this.isY('data.ppAssistingOnBehalf'))) && (this.user === 'RP' && (this.appType === 'RB' || this.appType === 'RC' || this.appType === 'REDETERMINATION' || this.isFinReassessment) && !this.isAHS);

      //PP FC condition
      const condition3 = (this.isY('data.ppAddAssistingPersonToApp') || this.isY('data.ppAssistingOnBehalf')) && (this.user === 'RP' && this.appType === 'AFB' && !this.isAHS);
      const relationship = this.getControl('data.assistingPerson.relationship');

      if( condition1 || condition2 || condition3) {
        relationship.enable();
        relationship.updateValueAndValidity();
      } else{
        relationship.disable();
        relationship.updateValueAndValidity();
      }
      applicantBehalf.clearValidators();
      applicantAckSignSw.disable();
      applicantAckSignSw.updateValueAndValidity();
      applicantAckSignSw.clearValidators();
      applicantSignName.disable();
      applicantSignName.clearValidators();

    }
    if (val === 'assistingPersonRelationship' && (this.getValue('data.assistingPerson.assistingPersonSignName') === "Signature on file" || this.getValue('data.assistingPerson.assistingPersonSignName') === "Firma en archivo")) {
      this.resetAssistingPersonNameAndCheckBox()
    }
  }

  resetAssistingPersonNameAndCheckBox() {
    this.getControl('data.assistingPerson.ackSignSw').reset();
    this.getControl('data.assistingPerson.ackSignSw').enable();
    this.getControl('data.assistingPerson.ackSignSw').updateValueAndValidity()
    this.getControl('data.assistingPerson.assistingPersonSignName').reset();
    this.getControl('data.assistingPerson.assistingPersonSignName').enable();
    this.getControl('data.assistingPerson.assistingPersonSignName').updateValueAndValidity()
    const assistingOnBehalf = this.getControl('data.assistingOnBehalf');
      if(assistingOnBehalf.value?.code === 'A') {
        this.getControl('data.assistingPerson.assistingPersonSignName').setValidators([Vs.maxLength(93), Vs.signatureName]);
        this.getControl('data.assistingPerson.assistingPersonSignName').updateValueAndValidity();
      }     
  }

  languageCheck(language) {
    this.tables = language === 'sp' ? formatTableData(this.tables, 'spDescription') : formatTableData(this.tables, 'description');
  }

  tableCodeValue(tableName, tableControl) {
    return this.getTableCodeValues(tableName, tableControl, this.translatedLang)
  }

  getLangData(data) {
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (this.translatedLang === 'sp') {
        element.description = element.spDescription;
        element.value = element.spDescription;
      }
    }
    return data;
  }

  ngAfterViewInit(): void {
    window.scroll(0,0);
    this.waitForTitle();
    
    // Reset signature only when firstName or lastName changes (ignore middleInitial)
    const name = this.getControl('data.assistingPerson.name');
    // Initialize previous values
    this.previousAssistingFirstName = name.value?.firstName || '';
    this.previousAssistingLastName = name.value?.lastName || '';
    
    name.valueChanges.pipe().subscribe((value)=> {
      const currentFirstName = value?.firstName || '';
      const currentLastName = value?.lastName || '';
      
      // Check if firstName or lastName changed (ignore middleInitial and suffix)
      const firstNameChanged = this.previousAssistingFirstName !== currentFirstName;
      const lastNameChanged = this.previousAssistingLastName !== currentLastName;
      
      if ((firstNameChanged || lastNameChanged) && 
          (this.getValue('data.assistingPerson.assistingPersonSignName') === "Signature on file" || 
           this.getValue('data.assistingPerson.assistingPersonSignName') === "Firma en archivo")) {
        this.resetAssistingPersonNameAndCheckBox();
      }
      
      // Update previous values
      this.previousAssistingFirstName = currentFirstName;
      this.previousAssistingLastName = currentLastName;
    });
    
    const assistPersonhelpDuration = this.getControl('data.assistingPerson.helpDuration');
    assistPersonhelpDuration.valueChanges.pipe().subscribe(()=> {
      if((this.getValue('data.assistingPerson.assistingPersonSignName') === "Signature on file" || this.getValue('data.assistingPerson.assistingPersonSignName') === "Firma en archivo")){
       this.resetAssistingPersonNameAndCheckBox()
      }
    })
  }

  /**
   * Focuses the page title for screen reader announcement. Retries up to 10 times to wait for async rendering.
   */
  private waitForTitle(attempts = 0): void {
    setTimeout(() => {
      const heading = document.querySelector('h1.page-title-h1') as HTMLElement;
      if (heading) {
        heading.style.outline = 'none';
        heading.focus();
      } else if (attempts < 10) {
        this.waitForTitle(attempts + 1);
      }
    }, 100);
  }

  ngAfterContentInit() {
    this.wellpointData();
    const isAFB = isApplyForBenefits(this.applicationType);
    this.isFullCoverageApp = (isAFB && this.user === 'RP') ? true : false;
    this.isRmbRmc = isRmbRmc(this.mode);
    this.applicantBehalf1 = isRedeMode(this.mode) ? 'APPLICANT_BEHALF_1' : (isChangeReport(this.mode) ? 'APPLICANT_BEHALF_1' : 'APPLICANT_BEHALF_3');
    this.appKey = isRedeMode(this.mode) && !this.isPreterm ? 'RENEWAL_NAME' : isRedeMode(this.mode) && this.isPreterm ? 'QFR' : (isChangeReport(this.mode) ? 'CHANGE_TEXT' : 'APPLICATION_TEXT');
    this.appKey2 = isRedeMode(this.mode) ? 'RENEWAL_NAME' : (isChangeReport(this.mode) ? 'CHANGE_TEXT2' : 'APPLICATION_TEXT');
    this.isFinReassessment = JSON.parse(sessionStorage.getItem('isReassessment'));
    this.isKepro = JSON.parse(sessionStorage.getItem('isKepro'));
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.languageCheck(this.defaultLanguage);
    this.translatedLang = this.defaultLanguage
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      if(this.getValue('data.assistingPerson.assistingPersonSignName') && (this.getValue('data.assistingPerson.assistingPersonSignName') === "Signature on file" || this.getValue('data.assistingPerson.assistingPersonSignName') === "Firma en archivo")) {
        if(this.translatedLang === 'en') {
          this.getControl('data.assistingPerson.assistingPersonSignName').patchValue('Signature on file')
        } else {
          this.getControl('data.assistingPerson.assistingPersonSignName').patchValue('Firma en archivo')
        }
      }
      this.languageCheck(res.lang);
    })

    if(this.user !== 'RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc){
      const ppAssistingOnBehalf = this.getControl('data.ppAssistingOnBehalf');
      const ppAddAssistingPersonToApp = this.getControl('data.ppAddAssistingPersonToApp');
      ppAddAssistingPersonToApp.disable();
      ppAddAssistingPersonToApp.clearValidators();
      ppAddAssistingPersonToApp.updateValueAndValidity();
      ppAssistingOnBehalf.disable();
      ppAssistingOnBehalf.clearValidators();
      ppAssistingOnBehalf.updateValueAndValidity();
    }

    if(!this.isAHS){
      const applicationDt = this.getControl('data.applicationDt');
      applicationDt.disable();
      applicationDt.clearValidators();
      applicationDt.updateValueAndValidity();
    }

    if(this.user === 'RP' && (this.appType === 'AFB' || this.isFinReassessment) && !this.isAHS){
      const assistingOnBehalf = this.getControl('data.assistingOnBehalf');
      const addAssistingPersonToApp = this.getControl('data.addAssistingPersonToApp');
      addAssistingPersonToApp.disable();
      addAssistingPersonToApp.clearValidators();
      addAssistingPersonToApp.updateValueAndValidity();
      assistingOnBehalf.disable();
      assistingOnBehalf.clearValidators();
      assistingOnBehalf.updateValueAndValidity();
    }
    // if((this.getValue('data.assistingOnBehalf').value != 'Assisting Person' || this.getValue('data.assistingOnBehalf').value != 'Persona que Ayuda') && this.isY('data.addAssistingPersonToApp')){
    //   this.getControl('data.assistingPerson.ackSignSw').disable();
    //   this.getControl('data.assistingPerson.ackSignSw').clearValidators();
    //   this.getControl('data.assistingPerson.assistingPersonSignName').disable();
    //   this.getControl('data.assistingPerson.assistingPersonSignName').clearValidators();
    //   this.getControl('data.assistingPerson.applicantAckSignSw').disable();
    //   this.getControl('data.assistingPerson.applicantAckSignSw').clearValidators();
    //   this.getControl('data.assistingPerson.applicantSignName').disable();
    //   this.getControl('data.assistingPerson.applicantSignName').clearValidators();
    // }
    const dateOfApplication = this.getControl('data.dateOfApplication');
    if (!this.isMedicAidApp) {
      dateOfApplication.disable();
    }
    const primaryLanguage = this.getControl('data.languagePreference.primaryLanguage');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (primaryLanguage.value) {
        const tableVar = this.tables.PRIMARYLANGUAGE.filter((item) => item.code === primaryLanguage.value.code);
        this.tableData(tableVar);
        primaryLanguage.patchValue(tableVar[0]);
      }
    }
    const letterLanguage = this.getControl('data.languagePreference.letterLanguage');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (letterLanguage.value) {
        const tableVar = this.tables.WRITTENLANGUAGE.filter((item) => item.code === letterLanguage.value.code);
        this.tableData(tableVar);
        letterLanguage.patchValue(tableVar[0]);
      }
    }
    const otherLanguageName = this.getControl('data.languagePreference.otherLanguageName');
    const addMailingInfo = this.getControl('extras.helpers.addMailingInfo');
    const relationship = this.getControl('data.assistingPerson.relationship');
    if (!this.isMedicAidApp) {
      if (relationship.value) {

        const tableVar = this.tables.AUTHREPRELATIONSHIP.filter((item) => item.code === relationship.value.code);
        this.tableData(tableVar);
        relationship.patchValue(tableVar[0]);
      }
    }
    //  else {
    //   relationship.disable();
    //   relationship.updateValueAndValidity();
    // }


    const assistingOnBehalf = this.getControl('data.assistingOnBehalf');
    const ppAddAssistingPersonToApp = this.getControl('data.ppAddAssistingPersonToApp');
    const addAssistingPersonToApp = this.getControl('data.addAssistingPersonToApp');
    // if (!this.isMedicAidApp && isNil(this.isFinReassessment && !this.isKepro)) {
    //   if (ppAddAssistingPersonToApp.value) {
    //     const tableVar = this.tables.MPASSTPER.filter((item) => item.code === ppAddAssistingPersonToApp.value.code);
    //     // this.tableData(tableVar);
    //     ppAddAssistingPersonToApp.patchValue(tableVar[0]);
    //   }
    // }

    if (!this.isMedicAidApp && isNil(this.isFinReassessment && !this.isKepro)) {
      if (assistingOnBehalf.value) {
        const tableVar = this.tables.MPASSTPER.filter((item) => item.code === assistingOnBehalf.value.code);
        // this.tableData(tableVar);
        assistingOnBehalf.patchValue(tableVar[0]);
      }
    }

    const homeless = this.getControl('data.homeless');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (homeless.value) {
        const tableVar = this.tables.YESNO.filter((item) => item.code === homeless.value.code);
        this.tableData(tableVar);
        homeless.patchValue(tableVar[0]);

      }
    }

    const sahPrgSw = this.getControl('data.sahPrgSw');
    if (sahPrgSw.value) {
      if  (sahPrgSw.value?.code === 'Y') {
        this.getControl('data.physicalAddress.address').disable();
      }
      const tableVar = this.tables.YESNO.filter((item) => item.code === sahPrgSw.value.code);
      this.tableData(tableVar);
      sahPrgSw.patchValue(tableVar[0]);
    }
    const sahCountyCd = this.getControl('data.sahCountyCd');
    if (sahCountyCd.value) {
      const tableVar = this.tables.COUNTY.filter((item) => item.code === sahCountyCd.value.code);
      this.tableData(tableVar);
      sahCountyCd.patchValue(tableVar[0]);
    }

    const addToApplication = this.getControl('data.addAssistingPersonToApp');
    const ppAssistingOnBehalf = this.getControl('data.ppAssistingOnBehalf');

    if (!this.isMedicAidApp && !this.isFinReassessment) {
      if (addToApplication.value) {
        if  (addToApplication.value?.code === 'Y') {
          relationship.enable();
        }
        const tableVar = this.tables.YESNO.filter((item) => item.code === addToApplication.value.code);
        this.tableData(tableVar);
        addToApplication.patchValue(tableVar[0]);
      }
    }


    if ((this.user === 'RP' && (this.appType === 'AFB' || this.isFinReassessment) && !this.isAHS)) {
      ppAssistingOnBehalf.clearValidators();
      ppAssistingOnBehalf.updateValueAndValidity();
      if(ppAssistingOnBehalf.value){
        if  (ppAssistingOnBehalf.value?.code === 'Y') {
          relationship.enable();
        }
      }
    }


    if( ((this.user !=='RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc) && (assistingOnBehalf.value?.code === 'A' || addAssistingPersonToApp.value?.code === 'Y'))
      || ((this.user === 'RP' && this.isFinReassessment) && (ppAssistingOnBehalf.value?.code === 'Y' || ppAddAssistingPersonToApp.value?.code === 'Y'))
      || ((this.user === 'RP' && this.appType === 'AFB' && !this.isAHS) && (ppAssistingOnBehalf.value?.code === 'Y' || ppAddAssistingPersonToApp.value?.code === 'Y')) ) {
      
      if(this.getValue('data.assistingPerson.assistingPersonSignName') !== "EXPORTED_AUTHREP_SIGN" && this.getValue('data.assistingPerson.assistingPersonSignName') !== "Signature on file" && this.getValue('data.assistingPerson.assistingPersonSignName') !== "Firma en archivo") {
        this.getControl('data.assistingPerson.ackSignSw').enable();
        this.getControl('data.assistingPerson.assistingPersonSignName').enable();
        if(assistingOnBehalf.value?.code === 'A') {
          this.getControl('data.assistingPerson.assistingPersonSignName').setValidators([Vs.maxLength(93), Vs.signatureName]);
          this.getControl('data.assistingPerson.assistingPersonSignName').updateValueAndValidity();
        }
      } 
      else {
        if(this.translatedLang === 'en'){
          this.getControl('data.assistingPerson.assistingPersonSignName').patchValue('Signature on file')
        } else {
          this.getControl('data.assistingPerson.assistingPersonSignName').patchValue('Firma en archivo')
        }
        
      }

    }

    if( ((this.user !=='RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc) && (assistingOnBehalf.value?.code === 'S' && addAssistingPersonToApp.value?.code === 'N'))
      || ((this.user === 'RP' && this.isFinReassessment) && (ppAssistingOnBehalf.value?.code === 'N' && ppAddAssistingPersonToApp.value?.code === 'N'))
      || ((this.user === 'RP' && this.appType === 'AFB' && !this.isAHS) && (ppAssistingOnBehalf.value?.code === 'N' && ppAddAssistingPersonToApp.value?.code === 'N')) ){
      this.getControl('data.assistingPerson.ackSignSw').disable();
      this.getControl('data.assistingPerson.assistingPersonSignName').disable();
      this.getControl('data.assistingPerson.applicantAckSignSw').disable();
      this.getControl('data.assistingPerson.applicantSignName').disable();
    }


    const helpDuration = this.getControl('data.assistingPerson.helpDuration');
    const name = this.getControl('data.assistingPerson.name');
    const organizationName = this.getControl('data.assistingPerson.organizationName');
    organizationName.setValidators([Vs.maxLength(256), Vs.invalidAssistingOrgName]);
    organizationName.updateValueAndValidity();
    if (organizationName.value && organizationName.errors) {
      this.isInvalidOrgName = true;
      organizationName.markAsTouched();
    }
    organizationName.valueChanges.pipe().subscribe(() => {
      this.isInvalidOrgName = organizationName.value && organizationName.errors ? true : false;
    });
    const idNumber = this.getControl('data.assistingPerson.idNumber');
    idNumber.setValidators([Vs.maxLength(20), Vs.invalidIdNumber]);
    idNumber.updateValueAndValidity();
    if (idNumber.value && idNumber.errors) {
      this.isInvalidIdNumber = true;
      idNumber.markAsTouched();
    }
    idNumber.valueChanges.pipe().subscribe(() => {
      this.isInvalidIdNumber = idNumber.value && idNumber.errors ? true : false;
    });
    const applicationSource = this.getControl('data.physicalAddress.applicationSource');
    const ackSignSw = this.getControl('data.assistingPerson.ackSignSw');
    const assistingPersonSignName = this.getControl('data.assistingPerson.assistingPersonSignName');

    ackSignSw.valueChanges.pipe().subscribe(() => {
      this.isAssistingPersonAndAckSignSwSame();
      if (((ackSignSw.value !== '' && ackSignSw.value !== null) && (assistingPersonSignName.value === '' || assistingPersonSignName.value === null)) || ((ackSignSw.value === '' || ackSignSw.value === null) && (assistingPersonSignName.value !== '' && assistingPersonSignName.value !== null))) {
        this.errorMessage = true;
        this.getControl('extras.helpers.errorMessage').setErrors({INVALID_ASSISTING_SIGN: true})
      } else {
        this.errorMessage = false;
        this.getControl('extras.helpers.errorMessage').setErrors(null)
      }
    });

    assistingPersonSignName.valueChanges.pipe().subscribe(() => {
      this.isAssistingPersonAndAckSignSwSame();
      if (((ackSignSw.value !== '' && ackSignSw.value !== null) && (assistingPersonSignName.value === '' || assistingPersonSignName.value === null)) || ((ackSignSw.value === '' || ackSignSw.value === null) && (assistingPersonSignName.value !== '' && assistingPersonSignName.value !== null))) {
        this.errorMessage = true
        this.getControl('extras.helpers.errorMessage').setErrors({INVALID_ASSISTING_SIGN: true})
      } else {
        this.errorMessage = false
        this.getControl('extras.helpers.errorMessage').setErrors(null)
      }
    });


    if(!applicationSource.value && this.isKepro){
      const tableVar = this.tables.APRNSOURCE;
      this.tableData(tableVar);
      applicationSource.patchValue(tableVar[3]);
      applicationSource.updateValueAndValidity();
    }


    this.registerToggle(applicationSource, (code) => sessionStorage.setItem('appSource', code?.value));

    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (applicationSource.value) {
        const tableVar = this.tables.APRNSOURCE.filter((item) => item.code === applicationSource.value.code);
        this.tableData(tableVar);
        applicationSource.patchValue(tableVar[0]);
      }
    }

    const bestTimeP = this.getControl('data.physicalAddress.bestTime');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (bestTimeP.value) {
        const tableVar = this.tables.CONTACTTIME.filter((item) => item.code === bestTimeP.value.code);
        this.tableData(tableVar);
        bestTimeP.patchValue(tableVar[0]);

      }
    }
    const addressFormatP = this.getControl('data.physicalAddress.addressFormat');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (addressFormatP.value) {
        const tableVar = this.tables.ADDRESSFORMATTYPES.filter((item) => item.code === addressFormatP.value.code);
        this.tableData(tableVar, 'AFP');
        addressFormatP.patchValue(tableVar[0]);

      }
    }
    const physicalAddress = this.getControl('data.physicalAddress.address');
    const physicalAddressState = this.getControl('data.physicalAddress.address.state');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (physicalAddressState.value) {
        const tableVar = this.tables.STATE.filter((item) => item.code === physicalAddressState.value.code);
        this.tableData(tableVar);
        physicalAddressState.patchValue(tableVar[0]);

      }
    }
    const physicalAddressCounty = this.getControl('data.physicalAddress.address.county');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (physicalAddressCounty.value) {
        const tableVar = this.tables.COUNTY.filter((item) => item.code === physicalAddressCounty.value.code);
        this.tableData(tableVar);
        physicalAddressCounty.patchValue(tableVar[0]);
      }
    }
    const assistPersonhelpDuration = this.getControl('data.assistingPerson.helpDuration');
    if (assistPersonhelpDuration.value) {
      const tableVar = this.tables.AUTHREPTIME.filter((item) => item.code === assistPersonhelpDuration.value.code);
      this.tableData(tableVar);
      assistPersonhelpDuration.patchValue(tableVar[0]);
    }

    const physicalAddressaddressAPO = this.getControl('data.physicalAddress.address.addrApoFpo');
    this.setDropdownValues(physicalAddressaddressAPO, this.tables.MILITARYPOCODES, 'POC')


    const physicalAddressaddressAaAe = this.getControl('data.physicalAddress.address.addrAaAeAp');
    this.setDropdownValues(physicalAddressaddressAaAe, this.tables.STATEMILITARY, 'SM')

    const mailingAddressaddressAPO = this.getControl('data.mailingAddress.address.addrApoFpo');
    this.setDropdownValues(mailingAddressaddressAPO, this.tables.MILITARYPOCODES, 'POC')


    const mailingAddressaddressAaAe = this.getControl('data.mailingAddress.address.addrAaAeAp');
    this.setDropdownValues(mailingAddressaddressAaAe, this.tables.STATEMILITARY, 'SM')
    const assistingAddressaddressAPO = this.getControl('data.assistingPerson.address.addrApoFpo');
    this.setDropdownValues(assistingAddressaddressAPO, this.tables.MILITARYPOCODES, 'POC')


    const assistingAddressaddressAaAe = this.getControl('data.assistingPerson.address.addrAaAeAp');
    this.setDropdownValues(assistingAddressaddressAaAe, this.tables.STATEMILITARY, 'SM')

    const addressFormatM = this.getControl('data.mailingAddress.addressFormat');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (addressFormatM.value) {
        const tableVar = this.tables.ADDRESSFORMATTYPES.filter((item) => item.code === addressFormatM.value.code);
        this.tableData(tableVar,'AFM');
        addressFormatM.patchValue(tableVar[0]);

      }
    }
    const mailingAddress = this.getControl('data.mailingAddress.address');
    const mailingAddressState = this.getControl('data.mailingAddress.address.state');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (mailingAddressState.value) {
        const tableVar = this.tables.STATE.filter((item) => item.code === mailingAddressState.value.code);
        this.tableData(tableVar);
        mailingAddressState.patchValue(tableVar[0]);

      }
    }
    const mailingAddressCounty = this.getControl('data.mailingAddress.address.county');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (mailingAddressCounty.value) {
        const tableVar = this.tables.COUNTY.filter((item) => item.code === mailingAddressCounty.value.code);
        this.tableData(tableVar);
        mailingAddressCounty.patchValue(tableVar[0]);
      }
    }


    const addressFormatA = this.getControl('data.assistingPerson.addressFormat');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (addressFormatA.value) {
        const tableVar = this.tables.ADDRESSFORMATTYPES.filter((item) => item.code === addressFormatA.value.code);
        this.tableData(tableVar, 'AFA');
        addressFormatA.patchValue(tableVar[0]);

      }
    }
    const assistAddress = this.getControl('data.assistingPerson.address');
    const assistingAddressState = this.getControl('data.assistingPerson.address.state');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (assistingAddressState.value) {
        const tableVar = this.tables.STATE.filter((item) => item.code === assistingAddressState.value.code);
        this.tableData(tableVar);
        assistingAddressState.patchValue(tableVar[0]);

      }
    }
    const assistingAddressCounty = this.getControl('data.assistingPerson.address.county');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (assistingAddressCounty.value) {
        const tableVar = this.tables.COUNTY.filter((item) => item.code === assistingAddressCounty.value.code);
        this.tableData(tableVar);
        assistingAddressCounty.patchValue(tableVar[0]);
      }
    }

    const bestTimeA = this.getControl('data.assistingPerson.bestTime');
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (bestTimeA.value) {
        const tableVar = this.tables.CONTACTTIME.filter((item) => item.code === bestTimeA.value.code);
        this.tableData(tableVar);
        bestTimeA.patchValue(tableVar[0]);

      }
    }

    const email = this.getControl('data.assistingPerson.email');
    const bestTime = this.getControl('data.assistingPerson.bestTime');
    const contactPhones = this.getControl('data.assistingPerson.contactPhones');
    const casehead = this.getControl('data.casehead');
    const responsibilities = this.getControl('data.assistingPerson.responsibilities');
    const applicantBehalf = responsibilities.get('applicantBehalf');
    const submitRenewal = responsibilities.get('submitRenewal');
    const otherLetter = responsibilities.get('letterOtherCommunication');
    const yourBehalf = responsibilities.get('yourBehalf');

    const assistControls = [
      name,
      organizationName,
      idNumber,
      addressFormatA,
      assistAddress,
      email,
      bestTime,
      contactPhones,
      relationship,
      responsibilities
    ];

    const isHomeless = [mailingAddress, addressFormatM];
    const notHomeless = [physicalAddress, addressFormatP, addMailingInfo];
    const permissionsControls = [applicantBehalf, submitRenewal, otherLetter, yourBehalf]

    responsibilities.setValidators(() => {
      const requiresResponsibility = relationship.value?.code === 'AR' || relationship.value?.code === 'OH';
      const hasResponsibility = responsibilities.value.applicantBehalf ||
        responsibilities.value.submitRenewal ||
        responsibilities.value.letterOtherCommunication ||
        responsibilities.value.yourBehalf;

      return requiresResponsibility && !hasResponsibility ? { required: true } : null;
    });

    this.registerToggle(
      addToApplication,
      toggles([
        swapControls(assistControls, isYes),
        swapControl(helpDuration, isYes)
      ])
    );

    if(this.user === 'RP' && (this.appType === 'AFB' || this.isFinReassessment) && !this.isAHS){
      this.registerToggle(
        ppAssistingOnBehalf,
        toggles([
          swapControls(assistControls, isYes),
          swapControl(helpDuration, isYes)
        ])
      );
    }

    if(this.user === 'RP' && (this.appType === 'AFB' || this.isFinReassessment) && !this.isAHS){
      this.registerToggle(
        ppAddAssistingPersonToApp,
        toggles([
          swapControls(assistControls, isYes),
          swapControl(helpDuration, isYes)
        ])
      );
    }


    physicalAddress.valueChanges.pipe().subscribe(() => {
      this.processService.addressValidated = false;
    });
    mailingAddress.valueChanges.pipe().subscribe(() => {
      this.processService.addressValidated = false;
    });
    assistAddress.valueChanges.pipe().subscribe(() => {
      this.processService.addressValidated = false;
    });

    this.registerToggle(relationship,
      toggles([
        swapControls(permissionsControls, permissionCodes),
        () => responsibilities.updateValueAndValidity()
      ])
    );
    responsibilities.updateValueAndValidity();


    if (this.isMedicAidApp || this.isFinReassessment) {
      this.registerToggle(ppAddAssistingPersonToApp,
        toggles([
          swapControl(ppAssistingOnBehalf, isNo),
          swapControls(assistControls, isYes)
        ])
      );
    } else {
      this.registerToggle(assistingOnBehalf,
        toggles([
          swapControl(addToApplication, isSelf),
          swapControls(assistControls, isAssistingPerson)
        ])
      );
    }

    this.registerToggle(
      homeless,
      toggles([
        swapControls(notHomeless, isNo),
        swapControls(isHomeless, isYes)
      ])
    );
    this.registerToggle(primaryLanguage, swapControl(otherLanguageName, isOther));

    this.registerToggle(addMailingInfo, swapControls([mailingAddress, addressFormatM], isNo));

    if (this.individuals.length) {
      if (this.individuals[0].name.firstName) {
        const { firstName, middleInitial, lastName, suffix } = this.individuals[0].name;
        this.fullName = join(' ', [firstName, middleInitial, lastName, suffix ? suffix.value : ''])
      }
    };

    const createName = () => {
      const { firstName, middleInitial, lastName, suffix } = casehead.value;
      this.fullName = join(' ', [firstName, middleInitial, lastName, suffix ? suffix.value : '']);
    }

    if (casehead.value) createName();

    this.registerToggle(casehead, () => createName());
    const createAssistingPersonName = () => {
      const assistingName = name.value;
      if (assistingName) {
        const { firstName, middleInitial, lastName, suffix } = assistingName;
        this.assistingPersonFullName = join(' ', [firstName, middleInitial, lastName, suffix ? suffix.value : '']);
      }
    };
    if (name.value) createAssistingPersonName();
    this.registerToggle(name, () => createAssistingPersonName());
    if (!mailingAddress.value.zip && !physicalAddress.value.zip) {
      addMailingInfo.setValue(({ code: '', value: '' }));
      setRequired(addMailingInfo);
    } else if (this.isEbmsDriverFlow) {
      if (mailingAddress.value.addressLine1)  {
        setValueNo(addMailingInfo)
      } else {
        setValueYes(addMailingInfo);
      }
    } else if (!mailingAddress.value.zip) {
      setValueYes(addMailingInfo);
    } else if (mailingAddress.value.zip) {
      setValueNo(addMailingInfo)
    }

    //Why specifically to MP and FRM? This is not setting the value for addmailinfo in FC
    // if (!this.isMedicAidApp) {
    if (addMailingInfo.value.code !== '') {
      const tableVar = this.tables.YESNO.filter((item) => item.code === addMailingInfo.value.code);
      if (tableVar.length > 0) {
        tableVar[0].value = addMailingInfo.value.value;
        addMailingInfo.setValue(tableVar[0]);
        dateOfApplication.disable();
      }
    }
    // }


    if (this.appType != 'PRG' && this.appType != 'HPE' && this.appType != 'BCC') {
      dateOfApplication.disable();
    }


    //MP help duration disable
    if (this.getValue('data.assistingOnBehalf').value === 'Assisting Person' || this.getValue('data.assistingOnBehalf').value === 'Persona que Ayuda') {
      helpDuration.clearValidators();
    }

    if( ((this.getValue('data.assistingOnBehalf').code === 'S') && this.isY('data.addAssistingPersonToApp')
      && (this.user !== 'RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc))
      || ((this.user === 'RP' && this.appType === 'AFB' && !this.isAHS) && (this.isY('data.ppAddAssistingPersonToApp') || this.isY('data.ppAssistingOnBehalf')))
      || ((this.user === 'RP' && this.isFinReassessment) && (this.isY('data.ppAddAssistingPersonToApp') || this.isY('data.ppAssistingOnBehalf')))
    ){
      helpDuration.enable();
    }
      if( ((this.user !=='RP' || this.isAhsRmbOrRmc || this.ppViewTccHoHrmbrmc) && (assistingOnBehalf.value?.code === 'A' || assistingOnBehalf.value?.code === 'S' || addToApplication.value?.code === 'Y'))
      || ((this.user === 'RP' && this.isFinReassessment) && (ppAssistingOnBehalf.value?.code === 'Y' || ppAddAssistingPersonToApp.value?.code === 'Y'))
      || ((this.user === 'RP' && this.appType === 'AFB' && !this.isAHS) && (ppAssistingOnBehalf.value?.code === 'Y' || ppAddAssistingPersonToApp.value?.code === 'Y')) ) {
      email.enable();
      email.updateValueAndValidity();
    }
  
    if(this.isEbmsDriverFlow && !email.value && ((this.getValue('data.assistingOnBehalf').code === 'S' && this.isY('data.addAssistingPersonToApp')) || this.getValue('data.assistingOnBehalf').code === 'A')){
      email.enable();
      email.updateValueAndValidity();
    }

    //PP FRM, FC help duration disable
    // if (this.getValue('data.ppAddAssistingPersonToApp').value === 'Yes' || this.getValue('data.ppAddAssistingPersonToApp').value === 'Si') {
    //   helpDuration.clearValidators();
    // }


    if (this.isMedicAidApp && this.isFinReassessment) {
      this.registerToggle(ppAddAssistingPersonToApp,
        toggles([
          swapControl(helpDuration, isYes),
          swapControls(assistControls, isYes)
        ])
      );
      this.toolTip = false;
    } else {
      this.toolTip = true;
    }

    this.signinService.getAccountData(sessionStorage.getItem('userName')).subscribe((data) => {
      if (!data || data != null){
        this.userData = data;
        this.partnerName = `${data['firstName']} ${data['lastName']}`;
        this.firstName = data['firstName'];
        this.lastName= data['lastName'];
        this.cdr.detectChanges();
      }
    })

    if (homeless.value && homeless.value.code === 'Y') {
        addMailingInfo.disable();
        if (this.isEbmsDriverFlow) {
          mailingAddress.enable();
          mailingAddress.updateValueAndValidity();
          
          addressFormatM.enable();
          addressFormatM.updateValueAndValidity();
        }
      }        

    const boxApplicantBehalf = this.getControl('data.assistingPerson.responsibilities.applicantBehalf');
    const boxLetterOtherCommunication = this.getControl('data.assistingPerson.responsibilities.letterOtherCommunication');
    const boxsubmitRenewal = this.getControl('data.assistingPerson.responsibilities.submitRenewal');
    const boxyourBehalf = this.getControl('data.assistingPerson.responsibilities.yourBehalf');
    const sahMailId = this.getControl('data.sahMailId');
    if (sahPrgSw.value) {
      if (sahPrgSw.value?.code === 'Y') {
        let isnum = /^\d+$/.test(sahMailId?.value);
        if(sahMailId.value?.length === 6 && sahMailId.value.substr(4,1) === '-'){
          this.getControl('data.sahMailId').patchValue(sahMailId.value.substr(0, 4) + sahMailId.value.substr(5));
        }
        if(sahMailId.value?.length === 5){
          let firstFour = `${sahMailId.value.substr(0,4)}`;
          let lastdigit =  `${sahMailId.value.substr(4)}`;
          const isfirstFourNum = /^\d+$/.test(firstFour);
          const isLastLetter = /^\d+$/.test(lastdigit);
          this.validSahMailId = isfirstFourNum && !isLastLetter;
        }
       
        if(sahMailId.value === null){
          this.sahmask = '0000-A||0000';
        }
        if(sahMailId !== null && sahMailId.value?.length === 5 && this.validSahMailId){
          this.sahmask = '0000-A'
        }else if(sahMailId.value?.length === 4 && isnum){
          this.sahmask = '0000'
        } else {
          this.sahmask = null;
          this.isInvalidSahMailId = true;
          this.getControl('data.sahhiddenField').setValidators(Vs.required);
          this.getControl('data.sahhiddenField').updateValueAndValidity();
        }
      }
    }

    if(boxApplicantBehalf?.value === 'A' || boxLetterOtherCommunication?.value === 'L' || boxsubmitRenewal?.value  === 'S' ||  boxyourBehalf?.value  === 'Y'){
      boxApplicantBehalf.enable();
      boxApplicantBehalf.updateValueAndValidity();
      boxLetterOtherCommunication.enable();
      boxLetterOtherCommunication.updateValueAndValidity();
      boxsubmitRenewal.enable();
      boxsubmitRenewal.updateValueAndValidity();
      boxyourBehalf.enable();
      boxyourBehalf.updateValueAndValidity();
    }

    const applicantAckSignSw = this.getControl('data.assistingPerson.applicantAckSignSw');
    const applicantSignName = this.getControl('data.assistingPerson.applicantSignName');
    if(applicantSignName.value === "EXPORTED_MEMBER_SIGN") {
      applicantSignName.patchValue(null);
      applicantSignName.updateValueAndValidity();
      applicantAckSignSw.patchValue(null);
      applicantAckSignSw.updateValueAndValidity();
    }
    if(relationship?.value?.code === 'AR' && (this.isY('data.addAssistingPersonToApp') ||
      (this.getValue('data.assistingOnBehalf')?.value === 'Assisting Person' || this.getValue('data.assistingOnBehalf')?.value === 'Persona que Ayuda')
      || this.isY('data.ppAddAssistingPersonToApp') || this.isY('data.ppAssistingOnBehalf'))){
      applicantAckSignSw.enable();
      applicantAckSignSw.updateValueAndValidity();
      applicantSignName.enable();
      applicantSignName.setValidators([Vs.required, Vs.maxLength(93), Vs.signatureName]);
      applicantAckSignSw.updateValueAndValidity();
    }else{
      applicantAckSignSw.disable();
      applicantAckSignSw.disable();
      applicantAckSignSw.updateValueAndValidity();
      applicantSignName.clearValidators();
      applicantSignName.clearValidators();
      applicantSignName.updateValueAndValidity();
    }
  }
  tableData(tableVar, tableField?: string) {
    let selectedLang = sessionStorage.getItem('globalTranslatedLan') && 
                      sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
    if(selectedLang === 'es') {
      selectedLang = 'sp';
    }
    const isGlobalLanguage = selectedLang && selectedLang !== 'en' && selectedLang !== 'sp';
    if (!this.isPpRmbRmc && !this.isAHS) {
      if (this.translatedLang === 'en' && tableVar.length > 0) {
        tableVar[0].value = tableVar[0].description || tableVar[0].value;
      } else if (this.translatedLang === 'sp' && tableVar.length > 0) {
        if (isGlobalLanguage && (tableField === 'AFM' || tableField ==='AFA' || tableField ==='AFP' || tableField ==='POC' || tableField ==='SM')) {
          tableVar[0].value = tableVar[0].description || tableVar[0].value;
        }else{
          tableVar[0].value = tableVar[0].spDescription || tableVar[0].spValue;
        }
      }
    }
    return tableVar;
  }

  homelessOnChange(_event: any) {
    const homeless = this.getControl('data.homeless');
    const sahProgram = this.getControl('data.sahPrgSw');
    if(homeless.value?.code === 'N' && sahProgram.value?.code !== 'Y'){
      const addMailingInfo = this.getControl('extras.helpers.addMailingInfo');
      setRequired(addMailingInfo);
      addMailingInfo.patchValue(({ code: '', value: '' }));
      addMailingInfo.setValue(null);  
      this.getControl('extras.helpers.addMailingInfo').setValidators(Vs.required);
      this.getControl('extras.helpers.addMailingInfo').updateValueAndValidity();
    }
  }

  safeAtHomeOnChange(_event: any) {
    const sahPrgSw = this.getControl('data.sahPrgSw');
    if(sahPrgSw.value?.code === 'Y'){
      this.sahmask = '0000||0000-A';
      this.getControl('data.sahMailId').setValidators([Vs.required, Vs.safeAtHomeMailID]);
      this.getControl('data.sahMailId').updateValueAndValidity();
      this.getControl('data.sahCountyCd').setValidators(Vs.required);
      this.getControl('data.sahCountyCd').updateValueAndValidity();
      const addMailingInfo = this.getControl('extras.helpers.addMailingInfo');
      addMailingInfo.setValue(({ code: '', value: '' }));
      // this.getControl('data.physicalAddress.addressFormat').setValue(({ code: '', value: '' }));
      this.getControl('data.physicalAddress.address').clearValidators();
      this.getControl('data.physicalAddress.address').reset();
      this.getControl('data.physicalAddress.address').disable();
      this.getControl('data.physicalAddress.addressFormat').reset();
      this.getControl('data.physicalAddress.addressFormat').clearValidators();
      this.getControl('data.physicalAddress.addressFormat').disable();
      this.getControl('data.physicalAddress.address').updateValueAndValidity();
      this.getControl('data.physicalAddress.addressFormat').updateValueAndValidity();
    }
    else{
      this.getControl('data.sahhiddenField').clearValidators();
      this.getControl('data.sahhiddenField').updateValueAndValidity();
      this.getControl('data.sahMailId').setValidators(null);
      this.getControl('data.sahMailId').setValue('');
      this.getControl('data.sahMailId').updateValueAndValidity();
      this.getControl('data.sahCountyCd').setValidators(null);
      this.getControl('data.sahCountyCd').setValue('');
      this.getControl('data.sahCountyCd').updateValueAndValidity();
      this.getControl('data.physicalAddress.address').enable();
      const homeless = this.getControl('data.homeless');

      if (homeless.value && homeless.value.code === 'Y') {
         this.getControl('data.mailingAddress.address').enable();
        this.getControl('data.mailingAddress.address.addrAaAeAp').disable();
        this.getControl('data.mailingAddress.address.addrApoFpo').disable();
        if(!this.getValue('data.mailingAddress.addressFormat')){
          this.getControl('data.mailingAddress.addressFormat').enable();
        }
        this.getControl('data.physicalAddress.address').disable();
      }
      if (homeless.value && homeless.value.code === 'N') {
        this.getControl('data.physicalAddress.address').enable();
        this.getControl('data.physicalAddress.address.addrAaAeAp').disable();
        this.getControl('data.physicalAddress.address.addrApoFpo').disable();
        if(!this.getValue('data.physicalAddress.addressFormat')){
          this.getControl('data.physicalAddress.addressFormat').enable();
        }
      const addMailingInfo = this.getControl('extras.helpers.addMailingInfo');
      addMailingInfo.patchValue(({ code: '', value: '' }));
      addMailingInfo.setValue(null);  
      this.getControl('extras.helpers.addMailingInfo').setValidators(Vs.required);
      this.getControl('extras.helpers.addMailingInfo').updateValueAndValidity();
      }
    }
  }
  // MP First question change event
  onAssistingPersonBehalfSelected(_event: any) {
    const assistingOnBehalf = this.getControl('data.assistingOnBehalf');
    if (assistingOnBehalf.value?.code === 'A') {
      this.getControl('data.assistingPerson.ackSignSw').setValue('');
      this.getControl('data.assistingPerson.assistingPersonSignName').setValue('');
      this.getControl('data.assistingPerson.assistingPersonSignName').setValidators([Vs.maxLength(93), Vs.signatureName]);
      this.getControl('data.assistingPerson.ackSignSw').enable();
      this.getControl('data.assistingPerson.assistingPersonSignName').enable();
      this.getControl('data.assistingPerson.relationship').enable();

      if((this.getValue('data.assistingPerson.relationship')?.code === 'AR') ){
        this.getControl('data.assistingPerson.applicantAckSignSw').enable();
        this.getControl('data.assistingPerson.applicantAckSignSw').setValue('');
        this.getControl('data.assistingPerson.applicantAckSignSw').setValidators(Vs.required);
        this.getControl('data.assistingPerson.applicantSignName').enable();
        this.getControl('data.assistingPerson.applicantSignName').setValue('');
        this.getControl('data.assistingPerson.applicantSignName').setValidators([Vs.required, Vs.maxLength(93), Vs.signatureName]);
      }

    } else {
      this.getControl('data.assistingPerson.ackSignSw').disable();
      this.getControl('data.assistingPerson.ackSignSw').clearValidators();
      this.getControl('data.assistingPerson.assistingPersonSignName').disable();
      this.getControl('data.assistingPerson.assistingPersonSignName').clearValidators();
      this.getControl('data.addAssistingPersonToApp').reset();
      this.getControl('data.addAssistingPersonToApp').setValidators(Vs.required);
      this.getControl('data.addAssistingPersonToApp').updateValueAndValidity();

      this.getControl('data.assistingPerson.applicantAckSignSw').disable();
      this.getControl('data.assistingPerson.applicantAckSignSw').clearValidators();
      this.getControl('data.assistingPerson.applicantSignName').disable();
      this.getControl('data.assistingPerson.applicantSignName').clearValidators();
    }
  }

  // MP Second question change event
  onAssistingPersonSelected(_event:any){
    const addAssistingPersonToApp = this.getControl('data.addAssistingPersonToApp');
    if (addAssistingPersonToApp.value?.code === 'Y') {
      this.getControl('data.assistingPerson.ackSignSw').setValue('');
      this.getControl('data.assistingPerson.assistingPersonSignName').setValue('');
      this.getControl('data.assistingPerson.ackSignSw').enable();
      this.getControl('data.assistingPerson.assistingPersonSignName').enable();
      this.getControl('data.assistingPerson.assistingPersonSignName').setValidators([Vs.maxLength(93), Vs.signatureName]);
      this.getControl('data.assistingPerson.relationship').enable();


      if((this.getValue('data.assistingPerson.relationship')?.code === 'AR') ){
        this.getControl('data.assistingPerson.applicantAckSignSw').enable();
        this.getControl('data.assistingPerson.applicantAckSignSw').setValue('');
        this.getControl('data.assistingPerson.applicantAckSignSw').setValidators(Vs.required);
        this.getControl('data.assistingPerson.applicantSignName').enable();
        this.getControl('data.assistingPerson.applicantSignName').setValue('');
        this.getControl('data.assistingPerson.applicantSignName').setValidators([Vs.required, Vs.maxLength(93), Vs.signatureName]);
      }
    }
    else {
      this.getControl('data.assistingPerson.ackSignSw').disable();
      this.getControl('data.assistingPerson.ackSignSw').clearValidators();
      this.getControl('data.assistingPerson.assistingPersonSignName').disable();
      this.getControl('data.assistingPerson.assistingPersonSignName').clearValidators();

      this.getControl('data.assistingPerson.applicantAckSignSw').disable();
      this.getControl('data.assistingPerson.applicantAckSignSw').clearValidators();
      this.getControl('data.assistingPerson.applicantSignName').disable();
      this.getControl('data.assistingPerson.applicantSignName').clearValidators();
    }
  }


  // PP First question change event
  ppOnAssistingPersonSelected(_event:any){
    const ppAddAssistingPersonToApp = this.getControl('data.ppAddAssistingPersonToApp');
    if (ppAddAssistingPersonToApp.value?.code === 'Y') {
      //FRM and FC code for partner's name
      this.getControl('data.assistingPerson.name').patchValue({ firstName: this.userData.firstName, lastName: this.userData.lastName });
      this.getControl('data.assistingPerson.ackSignSw').setValue('');
      this.getControl('data.assistingPerson.assistingPersonSignName').setValue('');
      this.getControl('data.assistingPerson.ackSignSw').enable();
      this.getControl('data.assistingPerson.assistingPersonSignName').enable();
      this.getControl('data.assistingPerson.relationship').enable();
      this.getControl('data.ppAssistingOnBehalf').disable();
      this.getControl('data.ppAssistingOnBehalf').updateValueAndValidity();
      this.getControl('data.assistingPerson.helpDuration').enable();
      this.getControl('data.assistingPerson.helpDuration').updateValueAndValidity();
    }
    else{
      this.getControl('data.assistingPerson.ackSignSw').disable();
      this.getControl('data.assistingPerson.assistingPersonSignName').disable();
      this.getControl('data.ppAssistingOnBehalf').reset();
      this.getControl('data.ppAssistingOnBehalf').enable();
      this.getControl('data.ppAssistingOnBehalf').setValidators(Vs.required);
      this.getControl('data.ppAssistingOnBehalf').updateValueAndValidity();

      this.getControl('data.assistingPerson.applicantAckSignSw').disable();
      this.getControl('data.assistingPerson.applicantAckSignSw').clearValidators();
      this.getControl('data.assistingPerson.applicantSignName').disable();
      this.getControl('data.assistingPerson.applicantSignName').clearValidators();
    }
  }

  // PP FC and FRM Second question change event
  ppOnAssistingPersonBehalfSelectedFCFRM(_event: any) {
    const ppAssistingOnBehalf = this.getControl('data.ppAssistingOnBehalf');
    if (ppAssistingOnBehalf.value?.code === 'Y') {
      this.getControl('data.assistingPerson.ackSignSw').setValue('');
      this.getControl('data.assistingPerson.assistingPersonSignName').setValue('');
      this.getControl('data.assistingPerson.ackSignSw').enable();
      this.getControl('data.assistingPerson.assistingPersonSignName').enable();
      this.getControl('data.assistingPerson.relationship').enable();

    } else {
      this.getControl('data.assistingPerson.ackSignSw').disable();
      this.getControl('data.assistingPerson.assistingPersonSignName').disable();
      this.getControl('data.assistingOnBehalf').disable();
      this.getControl('data.addAssistingPersonToApp').disable();

      this.getControl('data.assistingPerson.applicantAckSignSw').disable();
      this.getControl('data.assistingPerson.applicantAckSignSw').clearValidators();
      this.getControl('data.assistingPerson.applicantSignName').disable();
      this.getControl('data.assistingPerson.applicantSignName').clearValidators();
    }
  }



  validateAssistingPersonName() {
    const casehead = this.getControl('data.casehead');
    const name = this.getControl('data.assistingPerson.name');
    if (casehead ?.value ?.firstName ?.toLowerCase() === name ?.value ?.firstName ?.toLowerCase() && casehead ?.value ?.middleInitial ?.toLowerCase() === name ?.value ?.middleInitial ?.toLowerCase() &&
      casehead ?.value ?.lastName ?.toLowerCase() === name ?.value ?.lastName ?.toLowerCase() && casehead ?.value ?.suffix ?.toLowerCase() === name ?.value ?.suffix ?.toLowerCase()) {
      this.isAssistingPersonNameSameAsHoh = true;
    } else {
      this.isAssistingPersonNameSameAsHoh = false;
    }
    if (this.isAssistingPersonNameSameAsHoh) {
      this.getControl('data.hiddenField').setValidators(Vs.required);
      this.getControl('data.hiddenField').updateValueAndValidity();
    } else {
      this.getControl('data.hiddenField').clearValidators();
      this.getControl('data.hiddenField').updateValueAndValidity();
    }
    return this.isAssistingPersonNameSameAsHoh;
  }

  ngOnDestroy() {
    this.addressSub.unsubscribe();
  }
  setDropdownValues(control, table, field?: string) {
    if (!this.isMedicAidApp && !this.isFinReassessment && !this.isKepro) {
      if (control.value) {
        const tableVar = table ?.filter((item) => item.code === control.value.code);
        this.tableData(tableVar, field);
        control.patchValue(tableVar[0]);
      }
    }
  }

  omit_special_char(event) {
    const k = event.charCode;
    const input = event.target as HTMLInputElement;
    const currentValue = input.value || '';
    
    // Remove prefix "#" and dash to get clean position
    const cleanValue = currentValue.replace('#', '').replace('-', '');
    const effectivePosition = cleanValue.length;
    
    // First 4 positions (0-3): only allow numbers and backspace
    if (effectivePosition < 4) {
      return (k >= 48 && k <= 57) || k == 8; // Numbers 0-9 and backspace
    }
    
    // 5th position (index 4): only allow letters and backspace
    if (effectivePosition === 4) {
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8); // Letters and backspace
    }
    
    // Beyond 5th position: don't allow (though mask should prevent this)
    return k == 8; // Only backspace
  }

  onInput(event) {
    this.isInvalidSahMailId = false;
    const sahMailId = this.getControl('data.sahMailId');
    let isnum = /^\d+$/.test(sahMailId?.value);
    if (sahMailId.value?.length === 6 && sahMailId.value.substr(4,1) === '-') {
      this.getControl('data.sahMailId').patchValue(sahMailId.value.substr(0, 4) + sahMailId.value.substr(5));
    }
    if (sahMailId.value?.length === 5) {
      let firstFour = `${sahMailId.value.substr(0, 4)}`;
      let lastdigit = `${sahMailId.value.substr(4)}`;
      const isfirstFourNum = /^\d+$/.test(firstFour);
      const isLastLetter = /^\d+$/.test(lastdigit);
      this.validSahMailId = isfirstFourNum && !isLastLetter;
    }
    if (sahMailId !== null && sahMailId.value?.length === 5 && this.validSahMailId) {
      this.sahmask = '0000-A';
      this.getControl('data.sahhiddenField').clearValidators();
      this.getControl('data.sahhiddenField').updateValueAndValidity();
    } else if (sahMailId.value?.length === 4 && isnum) {
      this.sahmask = '0000||0000-A';
      this.getControl('data.sahhiddenField').clearValidators();
      this.getControl('data.sahhiddenField').updateValueAndValidity();
    } else if (((sahMailId.value?.length < 4 && isnum)|| sahMailId.value?.length === 0)) {
      this.sahmask = '0000-A||0000';
      sahMailId.setErrors({ INVALID_SAH_ALPHANUMERIC_CHARACTER: true });
      this.getControl('data.sahhiddenField').setValidators(Vs.required);
      this.getControl('data.sahhiddenField').updateValueAndValidity();
    } else if(sahMailId.value?.length){
      sahMailId.setErrors({ INVALID_SAH_ALPHANUMERIC_CHARACTER: true });
      this.getControl('data.sahhiddenField').setValidators(Vs.required);
      this.getControl('data.sahhiddenField').updateValueAndValidity();
    }else {
      this.getControl('data.sahhiddenField').clearValidators();
      this.getControl('data.sahhiddenField').updateValueAndValidity();
    }
    const input = event.target as HTMLTextAreaElement;
    const value = input.value;
    const error = this.getControl('data.sahMailId', this.formGroup);
    if (error.errors === null && value !== '#') {
      sahMailId.setErrors(null);
    } else {
      sahMailId.setErrors({ INVALID_SAH_ALPHANUMERIC_CHARACTER: true });
    }
  }

  onFocusOut() {
    const sahMailId = this.getControl('data.sahMailId');
    if (sahMailId.value?.length === 4) {
      let firstFour = `${sahMailId.value.substr(0, 4)}`;
      const isfirstFourNum = /^\d+$/.test(firstFour);
      if (isfirstFourNum) {
        let inputValue = sahMailId.value.replace('-', '');
        this.getControl('data.sahMailId').setValue(inputValue);
        this.getControl('data.sahMailId').updateValueAndValidity();
        this.getControl('data.sahMailId').clearValidators();
        this.getControl('data.sahMailId').updateValueAndValidity();
      }
    } else if((sahMailId.value === "" || sahMailId.value?.length < 4) && !this.isInvalidSahMailId){
      sahMailId.setErrors({INVALID_SAH_ALPHANUMERIC_CHARACTER: true});
    } else if(sahMailId.value?.length > 6 && !this.isInvalidSahMailId){
      sahMailId.setErrors({INVALID_SAH_ALPHANUMERIC_CHARACTER: true});
    }
  }

  wellpointData(): void {
    const fDate = new Date(this.serviceConfigService.getServerConfig()?.wellpointEffDate);
    const cDate = new Date(this.currentDate);
    if (cDate >= fDate) {
      this.showWellpoint = true;
    }
  }

}